import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AlertifyService } from 'src/app/services/alertify.service';
import { EmpresaService } from 'src/app/services/empresa.service';

@Component({
  selector: 'app-create-edit-empresa',
  templateUrl: './create-edit-empresa.component.html',
  styleUrls: ['./create-edit-empresa.component.scss'],
})
export class CreateEditEmpresaComponent implements OnInit {
  public documentos: any;
  registerForm: UntypedFormGroup;
  public isForEdit = false;
  public dataInput: any;
  public tituloTxt = 'Crear club';

  constructor(
    public empresaSvc: EmpresaService,
    private alertify: AlertifyService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<CreateEditEmpresaComponent>
  ) {
    this.dataInput = data;
    console.log('los datos de ingreso son: ', data);
    if (data != null) {
      this.isForEdit = true;
      this.tituloTxt = 'Editar club';
    }
  }

  ngOnInit(): void {
    this.registerForm = new UntypedFormGroup({
      id: new UntypedFormControl(''),
      razonSocial: new UntypedFormControl('', Validators.required),
      direccion: new UntypedFormControl(''),
      telefono: new UntypedFormControl(''),
      celular: new UntypedFormControl(''),
      email: new UntypedFormControl('', [Validators.required, Validators.email]),
      estado: new UntypedFormControl('', Validators.required),
     // valorSticker: new FormControl(''),
    });
    this.registerForm.get('estado')?.setValue(true);
    if (this.isForEdit) {
      this.registerForm.get('id')?.setValue(this.dataInput.id);
      this.registerForm
        .get('razonSocial')
        ?.setValue(this.dataInput.razonSocial);
      this.registerForm.get('direccion')?.setValue(this.dataInput.direccion);
      this.registerForm.get('telefono')?.setValue(this.dataInput.telefono);
      this.registerForm.get('celular')?.setValue(this.dataInput.celular);
      this.registerForm.get('email')?.setValue(this.dataInput.email);
      this.registerForm.get('estado')?.setValue(this.dataInput.estado);
     // this.registerForm.get('valorSticker')?.setValue(0);
      
    }
  }

  guardar() {
    console.log('guardar club');
    console.log(this.registerForm.value);
    if (this.isForEdit) {
      //aqui mando a editar
      this.empresaSvc.editEmpresa(this.registerForm.value).subscribe((res) => {
        console.log('resultado Editar: ', res);
        if (res) {
          this.alertify.success('Club actualizada');
          this.dialogRef.close(true);
        } else {
          this.alertify.error('El club no se ha podido actualizar');
        }
      });
    } else {
      //aqui mando a crearlo
      this.registerForm
        .get('id')
        ?.setValue('00000000-0000-0000-0000-000000000000');
        console.log(this.registerForm.value);
      this.empresaSvc.addEmpresa(this.registerForm.value).subscribe((res) => {
        console.log('resultado crear: ', res);
        if (res) {
          this.alertify.success('Club creado');
          this.dialogRef.close();
        } else {
          this.alertify.error(
            'El club ya existe, valide la información e intentelo de nuevo'
          );
        }
      });
    }
  }
}
